import { ContainerModule } from 'inversify';
import examResultStoreModule, { ExamResultStoreModuleSymbol } from './exam-result-store-module'
import examStoreModule, { ExamStoreModuleSymbol } from './exam-store-module';
import { ExamResultsQuerySymbol } from './exam-result-query';

export const examResultStateModule = new ContainerModule((bind) => {
  bind(ExamResultStoreModuleSymbol).toConstantValue(examResultStoreModule);
  bind(ExamResultsQuerySymbol).toDynamicValue((c) => c.container.get(ExamResultStoreModuleSymbol))
  bind(ExamStoreModuleSymbol).toConstantValue(examStoreModule)
});
